<template>
    <a class="link" :href="link.url">
        <img :src="link.icon">
        <span v-html="link.name"></span>
    </a>
</template>

<script>

    export default {
        name: "LinksBlockLink",
        props:["link"],
        data(){
            return{
            }
        },
    }
</script>

<style scoped>

    .link{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-decoration: none;
    }

    .link img{
        width: 100px;
        min-height: 100px;
        margin-bottom: 25px;
    }

    .link span{
        margin-bottom: 25px;
        margin-top: 12px;
        font-size: 32px;
        line-height: 1.17;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        color: #000;
        text-align: center;
    }

    .link-context-menu{
        opacity: 0;
        transition: 0.2s;
    }

    .link:hover .link-context-menu{
        opacity: 1;
    }

</style>